import * as React from "react";

export default function ErrorLabel({ children }) {
    return <h1 className="text-lg mt-3 text-red-500 font-bold">{children}</h1>;
}
